import React, { useCallback, useEffect, useState } from "react";
// import { CircularProgress } from "@material-ui/core";
import ReactPlayer from "react-player";

interface VideoPlayerOverlayProps {
  open: boolean;
  onClose: () => void;
  videoUrl: string;
  videoThumbnail?: string;
  title?: string;
  footer?: React.ReactNode;
}

const VideoPlayerOverlay = ({
  open,
  onClose,
  videoUrl,
  videoThumbnail,
  title,
  footer,
}: VideoPlayerOverlayProps) => {
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(true);

  const closePlayer = useCallback(() => {
    setIsOverlayVisible(false);
    window.setTimeout(() => {
      onClose();
      setIsVideoLoading(true);
    }, 280);
  }, [onClose]);

  useEffect(() => {
    if (!open) {
      setIsOverlayVisible(false);
      return;
    }

    setIsVideoLoading(true);

    const frame = window.requestAnimationFrame(() => {
      setIsOverlayVisible(true);
    });

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        closePlayer();
      }
    };

    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleEscape);

    return () => {
      window.cancelAnimationFrame(frame);
      document.body.style.overflow = "";
      document.removeEventListener("keydown", handleEscape);
    };
  }, [open, closePlayer]);

  if (!open || !videoUrl) {
    return null;
  }

  return (
    <div
      className={`video-card-player-overlay ${
        isOverlayVisible ? "is-visible" : ""
      }`}
      onClick={closePlayer}
      role="dialog"
      aria-modal="true"
      aria-label={title ? `${title} video player` : "Video player"}
    >
      <button
        type="button"
        className="video-card-player-close"
        onClick={closePlayer}
        aria-label="Close video player"
      >
        &times;
      </button>

      <div
        className="video-card-player-dialog"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="video-card-player-frame">
          {/* {isVideoLoading && (
            <div className="video-card-player-loader" aria-live="polite">
              <CircularProgress size={40} style={{ color: "#fff" }} />
              <span>Loading video...</span>
            </div>
          )} */}
          <ReactPlayer
            url={videoUrl}
            playing={!isVideoLoading}
            controls
            width="100%"
            height="100%"
            onReady={() => setIsVideoLoading(false)}
            onBuffer={() => setIsVideoLoading(true)}
            onBufferEnd={() => setIsVideoLoading(false)}
            config={{
              file: {
                attributes: {
                  poster: videoThumbnail,
                  playsInline: true,
                },
              },
            }}
          />
        </div>
        {title && <p className="video-card-player-title">{title}</p>}
        {footer && <div className="video-card-player-footer">{footer}</div>}
      </div>
    </div>
  );
};

export default VideoPlayerOverlay;
